import { Icon, IconButton, Tooltip } from '@material-ui/core';
import { ShowToast } from 'app/components/atoms';

const RefreshButton = ({ handleRefreshTable }) => {
  const refreshTable = async () => {
    try {
      await handleRefreshTable();
      ShowToast('success', 'Yenileme başarılı');
    } catch (error) {
      console.log('error ', error);
      ShowToast('error', 'Yenileme başarısız. Tekrar deneyin.');
    }
  };

  return (
    <>
      <Tooltip arrow title="Yenile" placement="top-end">
        <IconButton onClick={refreshTable}>
          <Icon>sync</Icon>
        </IconButton>
      </Tooltip>
    </>
  );
};

export default RefreshButton;
